import Nav from './nav';

export default Nav;
